import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";
import type { RootState } from "single-spa/store/types";

import { selectCompetitiveLandscapeSlice } from "../../store/selectors";
import { COMPETITIVE_LANDSCAPE_TABLE_KEY } from "../configuration/constants";

const select = createStatePropertySelector(selectCompetitiveLandscapeSlice);

export const selectCompetitiveResults = select("results");
export const selectIsFetchingResults = select("isFetchingResults");

export const selectIsRowsSelectionEnabled = select("isRowSelectionEnabled");
export const selectIsExcelDownloading = select("isExcelDownloading");

export const selectCompetitiveResultsData = (state: RootState) => {
    return selectCompetitiveResults(state).Data;
};
export const selectCompetitiveResultsCount = (state: RootState) => {
    return selectCompetitiveResults(state).TotalCount;
};
export const selectCompetitiveResultsFilters = (state: RootState) => {
    return selectCompetitiveResults(state).Filters;
};
/**
 * Which industry classification the response carries. Read this rather than the opt-in setting: the
 * two are resolved independently, and only the response can be wrong about its own contents.
 */
export const selectServesIndustryTaxonomy = (state: RootState) => {
    return Boolean(selectCompetitiveResultsFilters(state).industryTaxonomy);
};
export const selectCheckedWebsites = (state: RootState) => {
    const selectedRows = getTableSelectedItems(COMPETITIVE_LANDSCAPE_TABLE_KEY)(state);
    return selectedRows?.map((row) => row.Domain) ?? [];
};
